import { render } from "./ShippingDestination.vue?vue&type=template&id=2849375e&scoped=true"
import script from "./ShippingDestination.vue?vue&type=script&lang=ts"
export * from "./ShippingDestination.vue?vue&type=script&lang=ts"

import "./ShippingDestination.vue?vue&type=style&index=0&id=2849375e&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-2849375e"

export default script